<template lang="html">
  <modal
    name="message-modal"
    height="auto"
    width="416"
    :adaptive="true"
    :maxWidth="416"
    :clickToClose="clickToClose"
    class="message-modal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="modal-container">
      <div class="modal-header bold" v-if="headerMessage">
        {{headerMessage}}
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div class="body-16" v-html="bodyMessage" />
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer">
        <SymbiumButton
          text="Close"
          :onClick="close"
          :isSmall="true"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton },
  methods: {
    close() {
      this.$modal.hide('message-modal');
    },
    beforeOpen(event) {
      this.headerMessage = event.params.headerMessage
      this.bodyMessage = event.params.bodyMessage
      this.clickToClose = event.params.clickToClose
      this.beforeCloseCallback = event.params.beforeClose || (() => {})
    },
    beforeClose() {
      this.beforeCloseCallback()
    }
  },
  data() {
    return {
      headerMessage: null,
      bodyMessage: null,
      clickToClose: null,
      beforeCloseCallback: null,
    }
  }
}
</script>

<style lang="scss">
.message-modal {
  .modal-body {
    overflow: scroll;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 0px;  /* Remove scrollbar space */
      background: transparent;  /* Optional: just make scrollbar invisible */
    }
    /* Optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
        background: #FF0000;
    }
  }

  .modal-footer .oval-button {
    padding: 8px 16px;
    margin: 0;

    .text {
      line-height: 14px;
    }
  }
}
</style>
